var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("router-link", {
    attrs: { to: { name: "PromptEditorCanvas", params: { uuid: _vm.id } } },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ href, route, navigate, isActive, isExactActive }) {
          return [
            _c(
              "button",
              {
                staticClass: "w-100",
                attrs: { id: "prompt-editor-nav-btn" },
                on: { click: navigate },
              },
              [
                _c("div", { staticClass: "d-flex align-items-center gap-5" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "8",
                        viewBox: "0 0 12 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1.33325 0.666626L4.66659 3.99996L1.33325 7.33329M6.66659 7.33329H10.6666",
                          stroke: "white",
                          "stroke-width": "1.33333",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("trans")("Prompt Editor"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "fa fa-chevron-right" }),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }